import { Button, Typography, Grid2, useTheme } from '@mui/material';
import { Link } from 'react-router-dom';
import useAuth from 'hooks/useAuth';
import { useEffect, useState } from 'react';

interface NotFoundProps {
  icon: React.ComponentType<any> | null;
  text: string | any;
  link: string | null;
  categoryData?: Array<any>;
  add?: boolean;
  color?: string;
  disableButton?: boolean;

}
function NotFound({ icon: IconComponent, text, link, categoryData, disableButton }: NotFoundProps) {
  const { organization, user } = useAuth();
  const [canAdd, setCanAdd] = useState(link ? true : false);
  const theme = useTheme();
  const primaryColor = user?.type === 'student' ? "#063B9A" : theme.palette.primary.main;

  useEffect(() => {
    const areConditionsMet =
      categoryData?.length !== 0 &&
      organization?.tags?.length !== 0 &&
      organization?.language?.length !== 0 &&
      organization?.whatWeLearn?.length !== 0;

    if (areConditionsMet) {
      // Do something if all conditions are met
      setCanAdd(true);
    }
  }, [categoryData, organization]);
  return (
    <Grid2
      container
      direction="row"
      justifyContent="center"
      textAlign="center"
      alignItems="center"
      style={{ height: '100%', paddingTop: '50px', paddingBottom: '50px' }}
    >
      <Grid2 size={12}>
        {IconComponent && <IconComponent size="200" color={primaryColor} variant="Bold" />}
      </Grid2>
      <Grid2 size={12} margin={1}>
        <Typography sx={{ fontWeight: 'bold' }}>{text}</Typography>
        {link && canAdd && !disableButton ? (
          <Link to={user?.type === 'student' ? `/learner${link}` : link}>
            <Button disabled={disableButton} sx={{ margin: 1, px: 3, backgroundColor: primaryColor, pointerEvents: 'none' }} variant="contained">
              + Add
            </Button>
          </Link>
        ) : null}
      </Grid2>
    </Grid2>
  );
}

export default NotFound;
